import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {FormControl,FormGroup,Validators,FormBuilder,} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from 'src/app/services/order/order.service';
import { cityService } from 'src/app/services/city/city.service';
import { SettingService } from 'src/app/services/setting/setting.service';


@Component({
    selector: 'app-add-address',
    templateUrl: './add-address.component.html',
    styleUrls: ['./add-address.component.scss']
  })
  export class AddAddressComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();

    // Props
    public title: string;
    public type: string;
    public data: any;
    public pages: any;
    public editId: any

    // Loader
    public isBtnLoaded = false;
    public PatientTouchSubmit = false;

    // From Group
    public patientForm: FormGroup;

    // Dropdown List
    public statelistForDropdown = [];
    public citylistForDropdownByState = [];
    public areacodelistForDropdown = [];

    public uploadPincodeInput = 'No'
    public fileName: any;
    public file: any;
    public fileerrmsg: boolean;

    constructor(
        private ngbModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private cityService: cityService,
        private orderService: OrderService,
        private settingService: SettingService,
        private toastr: ToastrService,
    ) { }

    ngOnInit(): void {


      this.cityService.getallstateandId().subscribe((data) => {
        this.statelistForDropdown = data.data;
    });

        this.patientForm = this.formBuilder.group({

            address: ['', Validators.required,],
            city: ['',],
            city_id: ['', Validators.required,],
            state: ['', Validators.required,],
            pincode: ['', Validators.required,],
            user_id:[''],
            id:[''],
        });

        this.setDialogProps(this.props);
    }


    get patientInfo() {
        return this.patientForm.controls;
    }

    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.type = dialogdata.type;
        this.data = dialogdata.data;
        this.pages = dialogdata.page;
        if (['edit'].includes(this.type)) {
            this.editId = this.data.id;
            // this.patientForm.patchValue({'user_id':this.data.id});
            this.patientForm.patchValue(this.data.data);
            this.patientForm.get('state').setValue(this.data.data.state_id);
            this.getCitynamebystate(this.data.data.state_id);
        }
    }

    closeModal() {
        this.passEntry.next(this.pages);
        this.ngbModal.close();
    }

    create() {
       this.PatientTouchSubmit = true
        if (this.patientForm.valid) {
            this.isBtnLoaded = true;
            this.patientForm.patchValue({user_id:this.data});
            const selectedCity = this.citylistForDropdownByState.find(item => item.id === Number(this.patientForm.value.city_id));
            if (selectedCity) {
                this.patientForm.patchValue({city:selectedCity.city_name});
              }
            this.orderService.createAddress(this.patientForm.value).subscribe((res: any) => {
                if (res.success) {
                    this.toastr.success(`${res.message}`);
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(`Added Successfully`);
                    }
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                this.closeModal();
                this.isBtnLoaded = false;
            })
        }

        else {
            this.patientForm.markAllAsTouched();
        }
    }



    update(){
        this.PatientTouchSubmit = true;
        if (this.patientForm.valid) {
            this.isBtnLoaded = true;
            this.patientForm.patchValue({id:this.data.data.address_id});
            this.patientForm.patchValue({user_id:this.data.id});
            const selectedCity = this.citylistForDropdownByState.find(item => item.id === Number(this.patientForm.value.city_id));
            if (selectedCity) {
                this.patientForm.patchValue({city:selectedCity.city_name});
              }
            this.orderService.updateAddress(this.patientForm.value).subscribe((res: any) => {
                if (res.success) {
                    this.toastr.success(`${res.message}`);
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(`Added Successfully`);
                    }
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                this.closeModal();
                this.isBtnLoaded = false;
            })
        }

        else {
            this.patientForm.markAllAsTouched();
        }
    }

    getCitynamebystate(state_id: number) {

      this.citylistForDropdownByState = [];
      this.cityService.getallCitysandbyId(state_id).subscribe((data) => {
          this.citylistForDropdownByState = data.data;
      });
      }
}

